import { useTranslation } from 'react-i18next';
import { Button, Dropdown, Form, Layout, message, Modal, Space, TableColumnsType, TableProps } from "antd";
import { KeyboardEvent, useEffect, useState } from "react";

import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  MoreOutlined,
  UploadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
// import "./index.scss";
import FilterTableBlogContent from "../../../components/blog-and-forum/blog-content/filter-table/FilterTable";
import AddBlogContentDrawer from "../../../components/drawer/add-blog-content";
import CommonModal from "../../../components/modal/common";
import PageHeader from "../../../components/page-header/PageHeader";
import TableData from "../../../components/table-data/TableData";
import { routesConfig } from "../../../config/routes";
import { deleteContentBlog, getListContentBlog, publishContentBlog } from "../../../service/blog-and-forum";
import { formatDateV2 } from "../../../utils/converDate";
import { globalStore } from "../../../stores/stores";
// import CommonModal from "../../components/modal/common";

type Props = {
  title?: string;
};

const BlogContentPage = (props: Props) => {
  const { t } = useTranslation();
  const { reload } = globalStore()
  const [tab, setTab] = useState(1);
  const { title } = props;
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [listBlogContent, setListBlogContent] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [detailData, setDetailData] = useState<any>();

  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");

  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedConfirm, setIsOpenedConfirm] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>("");
  const [filterData, setFilterData] = useState<any>({
    createDate: null,
    status: null,
  });
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const getListData = async () => {
    const data = {
      page: pageNumber,
      size: pageSize,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      keyword: searchValue.trim(),
    }
    await getListContentBlog(data).then((res) => {
      setListBlogContent(res.data.data.universityBlogData)
      setTotalRecords(res.data.data.total)
    })
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  useEffect(() => {
    getListData();
  }, [tab, pageNumber, pageSize, statusOrder, reload]);

  const handleSubmitSearch = () => {
    getListData();
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData();
    }
  };

  const handleChangeInput = (e: any) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const gotoDetail = (record: any) => {
    navigate(`${routesConfig.detailPortalAdministration}/${record?.enterpriseId}`, {
      state: { mode: "detail", name: record?.name },
    });
  };

  const deletePortalAdmin = async () => {
    await deleteContentBlog(deleteId).then((res) => {
      if (res.status === 200) {
        message.success(t("Xoá bài đăng thành công", "Xoá bài đăng thành công"))
        setIsOpenedConfirm(false)
        getListData()
      }
    })
  };

  const postContentBlog = async (id: string | undefined) => {
    await publishContentBlog(id).then((res) => {
      if (res.status === 200) {
        message.success(t("Đăng bài thành công", "Đăng bài thành công"))
        getListData()
      }
    })
  };

  const renderStatus = (value: number) => {
    switch (value) {
      case 1:
        return <p>{t("Nháp", "Nháp")}</p>
        break;
      case 2:
        return <p>{t("Đã đăng", "Đã đăng")}</p>
        break;
      case 3:
        return <p>{t("Xoá", "Xoá")}</p>
        break;
      default:
        break;
    }
  }

  const menuItems = [
    {
      key: "1",
      label: t("Đăng bài", "Đăng bài"),
      icon: <UploadOutlined />,
    },
    {
      key: "2",
      label: t("Sửa bài đăng", "Sửa bài đăng"),
      icon: <EditOutlined />,
    },
    {
      key: "3",
      label: t("Xoá bài đăng", "Xoá bài đăng"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ]

  const menuItems2 = [
    {
      key: "2",
      label: t("Sửa bài đăng", "Sửa bài đăng"),
      icon: <EditOutlined />,
    },
    {
      key: "3",
      label: t("Xoá bài đăng", "Xoá bài đăng"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ]

  const dataColumns: TableColumnsType<any> = [
    {
      title: t("Số thứ tự", "Số thứ tự"),
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 3,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên nội dung", "Tên nội dung"),
      dataIndex: "name",
      key: "name",
      width: 5,
      sorter: true,
      render: (_: any, record, index: number) => {
        return (
          <div dangerouslySetInnerHTML={{ __html: record?.name }}></div>
        );
      },
    },
    {
      title: t("Ngày cập nhật", "Ngày cập nhật"),
      dataIndex: "name",
      key: "name",
      width: 13,
      render: (_: any, record) => {
        return (
          <>{record?.updatedDate ? formatDateV2(record?.updatedDate) : null}</>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "createdPortalDate",
      key: "createdPortalDate",
      width: 5,
      render: (_: any, record) => {
        return (
          <div className="flex items-center gap-2">
            <div className="table-status">
              <div
                className="color-icon"
                style={{
                  backgroundColor:
                    record.status === 1
                      ? "#1677FF"
                      : record.status === 2
                        ? "#24b524"
                        : record.status === 3
                          ? "gray"
                          : "white"
                }}
              ></div></div>
            {renderStatus(record?.status)}
          </div>
        );
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() => {
                  // navigate(
                  //   `${routesConfig.detailContentBlog}/${record.id}`,
                  //   { state: { id: record?.id } }
                  // );
                  window.open(`${routesConfig.blogContent}/${routesConfig.detailContentBlog}/${record.id}`, "_blank")
                }
                }
              >
                <EyeOutlined />
              </a>
              <Dropdown
                menu={{
                  items: record.status !== 2 ? menuItems : menuItems2,
                  onClick: ({ key }) => {
                    if (key === '1') {
                      Modal.confirm({
                        title: t("Xác nhận đăng bài", "Xác nhận đăng bài"),
                        content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi đăng bài", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi đăng bài"),
                        onOk: () => {
                          postContentBlog(record?.id)
                        },
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ", "Huỷ"),
                        centered: true,
                        icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }

                    if (key === '2') {
                      setDetailData(record);
                      setIsOpened(true);
                    }

                    if (key === "3") {
                      setDeleteId(record?.id)
                      setIsOpenedConfirm(true)
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space >
          </>
        );
      },
      fixed: "right",
      width: 3,
    },
  ];

  const handleOpenCreate = () => {
    // add course here
    setIsOpened(true);
    setDetailData({})
  };

  const listBreadcrumb = [
    {
      title: t('Quản trị vai trò', 'Quản trị vai trò'),
    },
  ]

  return (
    <Layout className="page-header-group portal-adminstration">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {

        }}
      >
        <div
          className={`page-header-group--layout ${showFilter ? "open-filter" : ""
            }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterTableBlogContent
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              dataColumns={dataColumns}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              handleChangeInput={handleChangeInput}
              selectedRowKeys={selectedRowKeys}
              tab={tab}
            />
          </div>
          <div className={`wrapper-filter`}>
          </div>
        </div>

        <div className="tabs-heading">
          <TableData
            dataTable={listBlogContent}
            dataColumns={dataColumns}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            loadingTable={loading}
            scroll={{ x: 1500, y: 600 }}
            totalRecords={totalRecords}
            setSelectedRowKeysProps={setSelectedRowKeys}
            handleTableChangeProps={handleTableChange}
            pagination={true}
          />
        </div>

        <AddBlogContentDrawer
          open={isOpened}
          handleClose={() => setIsOpened(false)}
          getListData={getListData}
          detailData={detailData}
        />
      </Form.Provider>

      <CommonModal
        open={isOpenedConfirm}
        title={t('Xoá bài đăng', 'Xoá bài đăng')}
        desc={t('Bài đăng đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá bài đăng này không?', 'Bài đăng đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá bài đăng này không?')}
        closeIcon={true}
        okText={t('Xác nhận', 'Xác nhận')}
        cancelText={t("Huỷ", "Huỷ")}
        icon={<WarningOutlined style={{ color: "red" }} />}
        confirm={deletePortalAdmin}
        closeModal={() => setIsOpenedConfirm(false)}
        className="modal-delete-common"
      />
    </Layout>
  );
};

export default BlogContentPage;
